export const getSubsriptionKey = (): string => {
  if (localStorage.getItem('subscriptionKey') !== null) {
    const key = localStorage.getItem('subscriptionKey')
    return key ? key : ''
  }
  return 'Your Microsoft Speech API Key'
}

export const getRegion = (): string => {
  if (localStorage.getItem('region') !== null) {
    const key = localStorage.getItem('region')
    return key ? key : ''
  }
  return 'eastus'
}

export const getOutputFormat = (): string => {
  if (localStorage.getItem('outputFormat') !== null) {
    const key = localStorage.getItem('outputFormat')
    return key ? key : ''
  }
  return '.csv'
}